import React from 'react';
import styled from 'styled-components';
import type { TopicInfo } from '@marty-js/api-sdk/types';
import { useTranslation } from '@marty-js/design/src/utils/translation';

export type Props = {
  topic: TopicInfo;
};

const Comments = styled.div`
  display: none;
`;
const Topics = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const Topic = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const TopicAuthor = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

export const CommentsStatic = ({ topic }: Props) => {
  const t = useTranslation();

  return (
    <Comments>
      {t('sdk.comments.title', { count: `(${topic?.postStream?.posts.length ?? 0})` ?? '' })}
      <Topics>
        {topic?.postStream?.posts
          .filter((post) => post?.cooked && post.cooked.trim() !== '')
          .map((post) => {
            const pattern = /\/u\/[^\s]+/g;
            const commentCooked = post.cooked.replace(pattern, (match) => `https://forum.clubic.com${match}`);

            return (
              <Topic key={post.id}>
                <TopicAuthor>{post.username}</TopicAuthor>
                <div dangerouslySetInnerHTML={{ __html: commentCooked }} />
              </Topic>
            );
          })}
      </Topics>
    </Comments>
  );
};
